import React from 'react';
import {MasterLayout} from 'components/layouts';
import {ProductDetail} from 'components/product-detail';
import title from 'constants/TitlePages.js';
import {Products} from 'api';
import { asyncConnect } from 'redux-connect';
import CONFIG from 'base/constants/config';

@asyncConnect([{
  key: 'product',
  promise: ({ match: { params }, store: { dispatch }, helpers }) => {
    return Products.actions.product.request({id: params.id}).then(response => {
      // document.title = response.data && response.data.name ? response.data.name : 'Danangtrade';

      let product = response.data;
      if (product.requestUpdateInfo) {
        product = Object.assign({}, product, product.requestUpdateInfo);
      }

      dispatch({
        type: 'SEO_INFO',
        data: {
          title: product.name,
          description: product.description,
          image: (product.images && product.images.length > 0 ) ? `${CONFIG.UploadImageURL}/crop/400x300/products/download/${product.images[0]}` : ''
        }
      });

      return Promise.resolve(response.data);
    }).catch((error) => {
      console.log(error)
    });

  }
}])
class ProductDetailPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  componentDidMount() {
    document.title = title.ProductDetailPage;
  }

  render() {
    return (
      <MasterLayout>
        {this.props.product &&
          <ProductDetail product={this.props.product}/>
        }
      </MasterLayout>
    );
  }
}

export default ProductDetailPage;



// WEBPACK FOOTER //
// ./pages/product-detail/ProductDetailPage.jsx